// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"e500176b","213":"8c5de3b4","239":"a8fe35a7","455":"ec61af2c"}[chunkId] + ".chunk.js";
};